import fetchGzipFromR2AsJsonViaCfFunctions from '../../utilities/r2Fetch';
import { hazardAttrs, selectHazardAttrById } from '../constants/hazardAttrs';

export const getHazardAttrNameById = (hazardAttrId) => {
  return selectHazardAttrById(hazardAttrId).name;
};

// Gets hazard data
export const fetchHazardData = async (hazardId) => {
  const hazard = hazardAttrs.find((attr) => attr.id === hazardId);
  const key = `${hazard.name.toLowerCase().replace("/"," ").split(" ").join("_")}_yearly.json.gzip`
  return await fetchGzipFromR2AsJsonViaCfFunctions(key);
};

// Transforms hazard data for use on map
const getHazardMapData = (data, start, end) => {
  try {
    let result = {};
    Object.entries(data).forEach(([attr, attrData]) => {
      result[attr] = {};
      Object.entries(attrData).forEach(([location, locationData]) => {
        result[attr][location] = 0;

        locationData.forEach(([year, num]) => {
          if (year >= start && year <= end) {
            result[attr][location] += num;
          }
        });
      });
    });
    return result;
  } catch {
    return {};
  }
};

export const updateHazardMapData = ({ state, county }, { start, end }) => {
  const stateMapData = getHazardMapData(state, start, end);
  const countyMapData = getHazardMapData(county, start, end);

  return { state: stateMapData, county: countyMapData };
};
